export const messages = {
  en: {
    shops: {
      queryCondition: 'Query Conditions',
      shopInfo: 'Shop Information',
      shopId: 'Shop ID',
      shopIdPlaceholder: 'Please enter shop ID',
      shopNumber: 'Shop Number',
      shopNumberPlaceholder: 'Please enter shop number (format: Building-Shop)',
      state: 'Status',
      statePlaceholder: 'Please select status',
      rented: 'Rented',
      sold: 'Sold',
      idle: 'Vacant',
      addShop: 'Add Shop',
      floor: 'Floor',
      owner: 'Owner/Tenant',
      contactNumber: 'Contact Number',
      builtUpArea: 'Built-up Area',
      roomArea: 'Indoor Area',
      startTime: 'Start Lease Time',
      endTime: 'End Lease Time',
      rent: 'Rent',
      feeCoefficient: 'Fee Coefficient',
      operation: 'Operation',
      rentAction: 'Rent',
      sellAction: 'Sell',
      unbind: 'Unbind',
      edit: 'Edit',
      delete: 'Delete',
      squareMeter: 'm²',
      layerUnit: 'F',
      confirmDelete: 'Confirm Delete',
      deleteTip: 'Deleting the shop will delete associated fees and payment records, and automatically unbind the owner!',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      building: 'Building',
      tenantPhone: 'Tenant Phone',
      tenantName: 'Tenant Name',
      leaseStart: 'Lease Start Date',
      leaseEnd: 'Lease End Date',
      remark: 'Remark',
      shopFloor: 'Shop Floor',
      feeCoefficientPlaceholder: 'Please enter fee coefficient',
      builtUpAreaPlaceholder: 'Please enter built-up area',
      roomAreaPlaceholder: 'Please enter indoor area',
      rentPlaceholder: 'Please enter rent amount',
      shopNumberRequired: 'Shop number is required',
      floorRequired: 'Shop floor is required',
      buildingRequired: 'Building is required',
      rentRequired: 'Rent is required',
      builtUpAreaRequired: 'Built-up area is required',
      roomAreaRequired: 'Indoor area is required',
      feeCoefficientRequired: 'Fee coefficient is required',
      tenantPhoneRequired: 'Tenant phone is required',
      tenantNameRequired: 'Tenant name is required',
      leaseStartRequired: 'Lease start date is required',
      leaseEndRequired: 'Lease end date is required',
      phoneFormatError: 'Invalid phone format',
      rentShop:'rent shop',
      sellShop:'sell shop'
    }
  },
  zh: {
    shops: {
      queryCondition: '查询条件',
      shopInfo: '商铺信息',
      shopId: '商铺ID',
      shopIdPlaceholder: '请填写商铺ID',
      shopNumber: '商铺编号',
      shopNumberPlaceholder: '商铺编号(格式:楼栋-商铺)',
      state: '状态',
      statePlaceholder: '请选择状态',
      rented: '已出租',
      sold: '已出售',
      idle: '空闲',
      addShop: '添加商铺',
      floor: '楼层',
      owner: '业主/租方',
      contactNumber: '联系电话',
      builtUpArea: '建筑面积',
      roomArea: '室内面积',
      startTime: '起租时间',
      endTime: '截租时间',
      rent: '租金',
      feeCoefficient: '算费系数',
      operation: '操作',
      rentAction: '出租',
      sellAction: '出售',
      unbind: '解绑',
      edit: '修改',
      delete: '删除',
      squareMeter: '平方米',
      layerUnit: '层',
      confirmDelete: '确认删除',
      deleteTip: '确认是否删除!删除房屋会关联删除房屋下的费用以及缴费记录，并且自动解绑业主！',
      cancel: '取消',
      confirm: '确认',
      save: '保存',
      building: '楼栋',
      tenantPhone: '租户手机号',
      tenantName: '租户姓名',
      leaseStart: '起租时间',
      leaseEnd: '截租时间',
      remark: '备注',
      shopFloor: '商铺楼层',
      feeCoefficientPlaceholder: '请填写算费系数',
      builtUpAreaPlaceholder: '请填写建筑面积',
      roomAreaPlaceholder: '请填写室内面积',
      rentPlaceholder: '请填写租金',
      shopNumberRequired: '商铺编号不能为空',
      floorRequired: '商铺楼层不能为空',
      buildingRequired: '楼栋不能为空',
      rentRequired: '租金不能为空',
      builtUpAreaRequired: '建筑面积不能为空',
      roomAreaRequired: '室内面积不能为空',
      feeCoefficientRequired: '算费系数不能为空',
      tenantPhoneRequired: '租户手机号不能为空',
      tenantNameRequired: '租户名称不能为空',
      leaseStartRequired: '起租时间不能为空',
      leaseEndRequired: '截租时间不能为空',
      phoneFormatError: '手机号格式错误',
      rentShop:'出租商铺',
      sellShop:'出售商铺'
    }
  }
}